var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "83295284-0db4-44c6-9559-8b08a9caf9d1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "d9cd9980-dd9f-4df3-95f9-541b883ad4ef"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(38.21 0 0 38.21 501.95 503.04)",
    id: "24c11a08-8e56-42c4-a7fb-c29e4cf622b8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12.02, -11.73)",
    d: "M 10.9 2.1 C 6.300000000000001 2.6 2.5999999999999996 6.300000000000001 2.0999999999999996 10.799999999999999 C 1.5999999999999996 15.5 4.3 19.7 8.399999999999999 21.299999999999997 C 8.7 21.4 9 21.2 9 20.8 L 9 19.2 C 9 19.2 8.6 19.3 8.1 19.3 C 6.699999999999999 19.3 6.1 18.1 6 17.400000000000002 C 5.9 17.000000000000004 5.7 16.700000000000003 5.4 16.400000000000002 C 5.1 16.3 5 16.3 5 16.2 C 5 16 5.3 16 5.4 16 C 6 16 6.5 16.7 6.7 17 C 7.2 17.8 7.800000000000001 18 8.1 18 C 8.5 18 8.799999999999999 17.9 9 17.8 C 9.1 17.1 9.4 16.400000000000002 10 16 C 7.7 15.5 6 14.2 6 12 C 6 10.9 6.5 9.8 7.2 9 C 7.1 8.8 7 8.3 7 7.6 C 7 7.2 7 6.6 7.3 6 C 7.3 6 8.7 6 10.1 7.3 C 10.6 7.1 11.3 7 12 7 C 12.7 7 13.4 7.1 14 7.3 C 15.3 6 16.8 6 16.8 6 C 17 6.6 17 7.2 17 7.6 C 17 8.4 16.9 8.799999999999999 16.8 9 C 17.5 9.8 18 10.8 18 12 C 18 14.2 16.3 15.5 14 16 C 14.6 16.5 15 17.4 15 18.3 L 15 20.900000000000002 C 15 21.200000000000003 15.3 21.500000000000004 15.7 21.400000000000002 C 19.4 19.900000000000002 22 16.300000000000004 22 12.100000000000001 C 22 6.1 16.9 1.4 10.9 2.1 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon3);
export default __webpack_public_path__ + "static/media/nav-icon3.4ad1ffe400ead0a7ddc2045609153434.svg";
export { ForwardRef as ReactComponent };